// LiveStreamCupidGiftEntry.js
'use strict';
import { connect } from 'react-redux';

import LiveStreamCupidGiftEntry from '../component/LiveStreamCupidGiftEntry.jsx';
import getMeData from '../selector/getMeData.js';
import { openGame } from '../action/gameActions.js';
import toggleModal from '../action/toggleModal.js';
import login from '../action/login.js';
import { Game, GameHost } from '../resource/gameConstants.js';

const mapStateToProps = state => {
  return {
    meId: getMeData(state, 'id'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onEnterGame: ({ streamId }) => {
      dispatch(
        openGame({
          gameId: Game.UGPP_CUPID_GIFT,
          host: GameHost.MODAL,
          streamId,
        })
      );
      dispatch(toggleModal({ modalId: 'LiveStreamGiftModal', isOpen: false }));
    },
    login: () => dispatch(login()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamCupidGiftEntry);
